import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

enum Keys {
  Y = 'Yes',
  N = 'No',
}

interface IsAffectedByReviewsFilter extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _IsAffectedByReviews: FC<IsAffectedByReviewsFilter> = props => {
  const options = Object.keys(Keys).map(key => ({
    value: key,
    hasFullWidth: true,
    label: Keys[key as keyof typeof Keys],
  }))

  return <CheckboxBasedFilter title="Is Affected By Reviews" options={options} {...props} />
}

export const IsAffectedByReviewsFilter = observer(_IsAffectedByReviews)
